




























































































import Debug from "@/components/utility/Debug.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import TheLayoutBase from "@/layouts/TheLayoutBase.vue";
import {
  BadRequestException,
  ConflictException,
  NotFoundException,
  ServiceUnavailableException,
  TooManyRequestsException
} from "@/lib/exceptions/http";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { SignCreateSignDtoGen } from "@/services/sign/v1/data-contracts";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { ReportModule } from "@/store/modules/report.store";
import { SignCreateModule } from "@/store/modules/sign-create.store";
import { Component, Vue } from "vue-property-decorator";
import SignFormDialog from "./SignFormDialog.vue";
import SignFormEditor from "./SignFormEditor.vue";
import SignFormEditorMobile from "./SignFormEditorMobile.vue";
import SignFormSigned from "./SignFormSigned.vue";
import { LanguageCodeEnum } from "@/lib/enum/language-code.enum";

@Component({
  components: {
    TheLayoutBase,
    LayoutReport,
    Debug,
    SignFormEditor,
    SignFormEditorMobile,
    SignFormSigned,
    SignFormDialog,
    Tooltip
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class SignForm extends Vue {
  /**
   * Loading for backend requests
   */
  isLoading = false;
  isSaving = false;
  isValid = false;

  isError = false;
  isSigned = false;
  isPdfLoaded = false;

  errorTitle = "sign.Sign.error.title";

  terms = false;

  get signed() {
    return SignCreateModule.signed;
  }

  get signRequest() {
    return SignCreateModule.request;
  }

  get partner() {
    return ReportModule.partner;
  }

  confirmed() {
    const requestId = this.$route.params.signRequestId;
    const partnerId = this.partner._id;

    // here we change the status to `DELIVERED` in the background (to not block the UI)
    SignCreateModule.setDelivered({
      partnerId,
      requestId
    }).catch(
      // we are swallowing the error here, because it is not critical
      e => this.$log.error(e)
    );
  }

  async findSigned() {
    this.$log.warn("findSigned");

    const requestId = this.$route.params.signRequestId;
    const partnerId = this.partner._id;

    try {
      const signed = await SignCreateModule.findSigned({ partnerId, requestId });
      this.isError = false;

      this.isSigned = true;
      return signed;
    } catch (error) {
      if (error instanceof TooManyRequestsException) {
        this.errorTitle = "sign.Sign.error.tooManyRequests";
        this.$toast.error(this.$t("sign.Sign.error.tooManyRequests"));
      } else if (error instanceof ServiceUnavailableException) {
        this.errorTitle = "sign.Sign.error.serviceUnavailable";
        this.$toast.error(this.$t("sign.Sign.error.serviceUnavailable"));
      } else {
        this.errorTitle = "sign.Sign.error.signingUnavailable";
      }

      this.isError = true;
    }
  }

  async onSign(createSignRequestDto: SignCreateSignDtoGen) {
    try {
      this.isSaving = true;

      const tokens = DocumentTemplateModule.documentTokens;

      for (const page of tokens) {
        for (const token of page) {
          switch (token.token) {
            case "{{sign.firstName}}":
              token.value = createSignRequestDto.firstName;
              break;
            case "{{sign.lastName}}":
              token.value = createSignRequestDto.lastName;
              break;
            case "{{sign.location}}":
              token.value = createSignRequestDto.location;
              break;
            case "{{sign.created}}":
              token.value = new Date().toLocaleDateString("de-DE");
              break;

            default:
              break;
          }
        }
      }

      const data: SignCreateSignDtoGen = {
        ...createSignRequestDto,
        tokens: tokens
      };

      data.language = this.$i18n.locale as LanguageCodeEnum;

      await SignCreateModule.create({
        partnerId: this.signRequest.partnerId,
        requestId: this.signRequest.requestId,
        data
      });

      this.$toast.success(this.$t("sign.Sign.success"));

      await this.findSigned();

      this.isSigned = true;
    } catch (error) {
      if (error instanceof ConflictException) {
        this.errorTitle = "sign.Sign.error.signingUnavailable";
        this.isError = true;
      } else {
        handleError(error);
      }
    } finally {
      this.isSaving = false;
    }
  }

  async mounted() {
    this.isLoading = true;
    const requestId = this.$route.params.signRequestId;
    const partnerId = this.partner._id;

    try {
      await SignCreateModule.find({ partnerId, requestId });
    } catch (error) {
      this.$log.error(error);
      if ((error as any).message === "Signature Request expired") {
        this.errorTitle = "sign.Sign.error.expired";
        this.$toast.error(this.$t("sign.Sign.error.expired"));
        this.isError = true;
      } else if (error instanceof ConflictException) {
        await this.findSigned();
      } else if (error instanceof BadRequestException) {
        this.errorTitle = "sign.Sign.error.title";
        this.$toast.error(this.$t("sign.Sign.error.title"));
        this.isError = true;
      } else if (error instanceof NotFoundException) {
        this.errorTitle = "sign.Sign.error.404";
        this.$toast.error(this.$t("sign.Sign.error.404"));
        this.isError = true;
      }
    } finally {
      this.isLoading = false;
    }
  }
}
